import SettingsProfileContainer from './containers/SettingsProfileContainer';

export default SettingsProfileContainer;
